import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function BatchVideoProduction() {
  const [children, setChildren] = useState([])
  const [selectedChildren, setSelectedChildren] = useState([])
  const [batches, setBatches] = useState([])
  const [loading, setLoading] = useState(true)
  const [creating, setCreating] = useState(false)
  const [batchDetail, setBatchDetail] = useState(null)
  const [batchCodes, setBatchCodes] = useState({})
  const [musicOptions, setMusicOptions] = useState([{ key: 'warm', label: '🎵 Warm', file: 'warm.mp3' }])
  const [options, setOptions] = useState({ template: 'standard', music: 'warm', photo_duration: 3, transition: 'fade', subtitleEnabled: true, subtitleColor: 'white', subtitleFontSize: 48, subtitlePosition: 'bottom', enableNarration: false, narrationText: '', voiceId: 'zh-CN-YunjianNeural', bgmVolume: 0.3 })

  // 从后端动态加载BGM列表（优先 /api/music/library，备用 /api/growth-video/music）
  const loadMusicList = async () => {
    try {
      const res = await fetch(`${API}/music/library`);
      const json = await res.json();
      if (json.success && json.data && json.data.length > 0) {
        const formatted = (json.data || []).map(m => ({
          key: (m.file_path || '').split('/').pop().replace('.mp3', '').toLowerCase(),
          label: '🎵 ' + (m.name || m.file_path.split('/').pop().replace('.mp3', '')),
          file: m.file_path.split('/').pop()
        }));
        // 加一个"无背景音乐"选项
        formatted.push({ key: 'none', label: '🔇 无背景音乐', file: '' });
        setMusicOptions(formatted);
        return;
      }
    } catch(e) { console.log('music/library不可用:', e.message) }
    // 备用：从growth-video/music接口获取
    try {
      const res2 = await fetch(`${API}/growth-video/music`);
      const json2 = await res2.json();
      if (json2.success && json2.data) {
        const list = json2.data.options || [];
        if (list.length > 0) {
          const formatted = list.map(m => ({
            key: m.key || m.name,
            label: '🎵 ' + (m.label || m.name || m.key),
            file: m.file || m.key + '.mp3'
          }));
          formatted.push({ key: 'none', label: '🔇 无背景音乐', file: '' });
          setMusicOptions(formatted);
          return;
        }
      }
    } catch(e) { console.log('growth-video/music也不可用:', e.message) }
  }

  useEffect(() => { loadChildren(); loadBatches(); loadMusicList() }, [])
  useEffect(() => { const i = setInterval(() => { loadBatches(); if (batchDetail?.id) viewBatchDetail(batchDetail.id) }, 8000); return () => clearInterval(i) }, [batchDetail?.id])

  const loadChildren = () => { fetch(`${API}/children`).then(r => r.json()).then(d => { if (d.success) setChildren(d.data || []) }).finally(() => setLoading(false)) }
  const loadBatches = () => { fetch(`${API}/batch-video/tasks`).then(r => r.json()).then(d => { if (d.success) setBatches(d.data || []) }) }

  const deleteBatch = async (batchId) => {
    if (!confirm('确定要删除这个批次吗？')) return
    try {
      const res = await fetch(`${API}/batch-video/tasks/${batchId}`, { method: 'DELETE' })
      const json = await res.json()
      if (json.success) { alert('删除成功'); loadBatches() } 
      else alert('删除失败: ' + (json.error || '未知错误'))
    } catch (e) { alert('删除失败') }
  }
  const toggleChild = (child) => { const is = selectedChildren.find(c => c.id === child.id); setSelectedChildren(is ? selectedChildren.filter(c => c.id !== child.id) : [...selectedChildren, child]) }
  const selectAll = () => setSelectedChildren([...children])
  const clearSelection = () => setSelectedChildren([])

  const createBatchTask = () => {
    if (selectedChildren.length === 0) { alert('请选择至少一个孩子'); return }
    setCreating(true)
    fetch(`${API}/batch-video/tasks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ institution_id: localStorage.getItem('boxiaotu_institution_id') || 'INST001', children: selectedChildren.map(c => ({ child_id: c.id, title: `${c.name}的成长纪念片` })), ...options }) })
      .then(r => r.json()).then(d => { if (d.success) { alert(`🎉 已创建${d.data.total_children} 个视频制作任务！`); setSelectedChildren([]); loadBatches() } else alert('创建失败: ' + (d.error || '未知错误')) })
      .catch(() => alert('创建失败，请稍后重试')).finally(() => setCreating(false))
  }

  const viewBatchDetail = (batchId) => {
    fetch(`${API}/batch-video/tasks/${batchId}`).then(r => r.json()).then(d => {
      if (d.success) {
        setBatchDetail(d.data)
        const tasks = d.data.tasks || []
        const codes = {}
        Promise.all(tasks.map(t => fetch(`${API}/claim-codes?task_id=${t.id}&limit=10`).then(r => r.json()).then(c => { if (c.success && c.data) codes[t.id] = c.data.list || c.data }))).then(() => setBatchCodes(codes))
      }
    })
  }

  const generateCodes = (batchId) => {
    if (!confirm('确定要为这个批次的视频生成领取码吗？')) return
    fetch(`${API}/batch-video/generate-codes`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ batch_id: batchId }) })
      .then(r => r.json()).then(d => { if (d.success) { alert(`🎁 已生成${d.data.codes_count} 个领取码！`); viewBatchDetail(batchId) } else alert('生成失败: ' + (d.error || '未知错误')) })
  }

  const copyToClipboard = (text) => { navigator.clipboard.writeText(text).then(() => alert('已复制到剪贴板')).catch(() => { const el = document.createElement('input'); el.value = text; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); alert('已复制到剪贴板') }) }
  const sendSms = (childName, url) => { const body = encodeURIComponent(`${childName || '孩子'}的成长纪念视频，点击领取：${url}`); window.location.href = `sms:?body=${body}` }

  const getStatusBadge = (status) => {
    const map = { pending: { bg: '#fffbe6', color: '#faad14', text: '待处理' }, processing: { bg: '#e6f4ff', color: '#1890ff', text: '制作中' }, completed: { bg: '#f6ffed', color: '#52c41a', text: '已完成' }, codes_generated: { bg: '#f6ffed', color: '#722ed1', text: '已生成领取码' }, failed: { bg: '#fff1f0', color: '#ff4d4f', text: '失败' } }
    const s = map[status] || map.pending
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: s.bg, color: s.color }}>{s.text}</span>
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🎬 批量制作成长视频</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>一次为多个孩子制作成长纪念视频</p>

      {selectedChildren.length > 0 && (
        <div style={{ background: '#1890ff', color: '#fff', padding: '12px 16px', borderRadius: 8, marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>已选择 <strong>{selectedChildren.length}</strong> 个孩子</span>
          <div><button onClick={selectAll} style={{ ...btnStyle, background: 'rgba(255,255,255,0.2)', color: '#fff', marginRight: 8 }}>全选</button><button onClick={clearSelection} style={{ ...btnStyle, background: 'rgba(255,255,255,0.2)', color: '#fff' }}>清空</button></div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12, marginBottom: 24 }}>
        {children.map(child => {
          const is = selectedChildren.find(c => c.id === child.id)
          return (
            <div key={child.id} onClick={() => toggleChild(child)} style={{ padding: 16, background: is ? '#e6f4ff' : '#fff', border: is ? '2px solid #1890ff' : '1px solid #f0f0f0', borderRadius: 8, cursor: 'pointer', transition: 'all 0.2s' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>{child.gender === '女' ? '👧' : '👦'}</div>
                <div><div style={{ fontWeight: 500 }}>{child.name}</div><div style={{ fontSize: 12, color: '#999' }}>{child.school || '未设置学校'}</div></div>
              </div>
            </div>
          )
        })}
        {children.length === 0 && !loading && <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 40, color: '#999' }}>暂无孩子数据，请先在客户管理中添加</div>}
      </div>

      {selectedChildren.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24, marginBottom: 20 }}>
          <h3 style={{ fontSize: 14, marginBottom: 16 }}>视频设置</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
            {[
              { label: '模板', key: 'template', opts: [['standard','标准版'],['warm','温馨版'],['活泼','活泼版']] },
              { label: '背景音乐', key: 'music' },
              { label: '照片时长(秒)', key: 'photo_duration', opts: [[2,'2秒'],[3,'3秒'],[5,'5秒']] },
              { label: '转场效果', key: 'transition', opts: [['fade','淡入淡出'],['slide','滑动'],['zoom','缩放']] },
              { label: '字幕颜色', key: 'subtitleColor', opts: [['white','白色'],['yellow','黄色'],['gold','金色'],['blue','蓝色']] },
              { label: '字幕大小', key: 'subtitleFontSize', opts: [[36,'小(36px)'],[48,'中(48px)'],[60,'大(60px)']] },
              { label: '字幕位置', key: 'subtitlePosition', opts: [['bottom','底部'],['middle','中间'],['top','顶部']] },
            ].map(({ label, key, opts }) => {
              // 背景音乐：使用动态加载的音乐列表
              if (key === 'music') {
                return (
                  <div key={key}><label style={labelStyle}>{label}</label>
                    <select value={options[key]} onChange={e => setOptions({...options, music: e.target.value})} style={inputStyle}>
                      {musicOptions.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}
                    </select>
                  </div>
                );
              }
              return (
                <div key={key}><label style={labelStyle}>{label}</label>
                  <select value={options[key]} onChange={e => setOptions({...options, [key]: isNaN(e.target.value) ? e.target.value : Number(e.target.value)})} style={inputStyle}>
                    {opts.map(([v, t]) => <option key={v} value={v}>{t}</option>)}
                  </select>
                </div>
              );
            })}
          </div>

          {options.enableNarration && (
            <div style={{ marginTop: 16, padding: 16, background: '#f6f0ff', borderRadius: 8, border: '1px solid #722ed133' }}>
              <div style={{ marginBottom: 8, fontSize: 13, color: '#722ed1' }}>📝 批量统一旁白文本（所有孩子共用同一文本，系统自动插入姓名）</div>
              <textarea value={options.narrationText} onChange={e => setOptions({...options, narrationText: e.target.value})} placeholder="例如：{name}的成长故事开始了！" style={{ width: '100%', minHeight: 80, padding: 10, borderRadius: 6, border: '1px solid #d9d9d9', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
              <div style={{ marginTop: 6, fontSize: 11, color: '#888' }}>可用占位符：{'{name}'} = 孩子姓名（自动替换），{'{age}'} = 年龄</div>
              <div style={{ marginTop: 8 }}><label style={{ ...labelStyle, color: '#722ed1' }}>BGM音量</label><input type="range" min="0" max="1" step="0.1" value={options.bgmVolume} onChange={e => setOptions({...options, bgmVolume: parseFloat(e.target.value)})} style={{ width: '100%' }} /><div style={{ fontSize: 11, color: '#888' }}>当前: {Math.round(options.bgmVolume * 100)}%</div></div>
            </div>
          )}

          <div style={{ marginTop: 16, display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            <button onClick={createBatchTask} disabled={creating} style={{ padding: '12px 32px', background: creating ? '#ccc' : '#52c41a', color: '#fff', border: 'none', borderRadius: 8, cursor: creating ? 'not-allowed' : 'pointer', fontSize: 15, fontWeight: 600 }}>
              {creating ? '创建中...' : `🎬 批量创建 ${selectedChildren.length} 个视频`}
            </button>
            {options.enableNarration && options.narrationText && <div style={{ fontSize: 12, color: '#722ed1', background: '#f6f0ff', padding: '6px 12px', borderRadius: 6 }}>🎙️含配音旁白 | BGM {Math.round(options.bgmVolume * 100)}%</div>}
            {!options.enableNarration && <div style={{ fontSize: 12, color: '#faad14', background: '#fffbe6', padding: '6px 12px', borderRadius: 6 }}>🏷️含水印LOGO（免费体验版）</div>}
          </div>
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
        <h3 style={{ fontSize: 14, marginBottom: 16 }}>历史批次</h3>
        {batches.length === 0 ? <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无批量任务记录</div> : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#fafafa' }}>{['批次ID','孩子数量','完成/失败','状态','创建时间','操作'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {batches.map(b => (
                <tr key={b.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ ...td, fontFamily: 'monospace', fontSize: 12 }}>{b.id}</td>
                  <td style={td}>{b.tasks_count} 个</td>
                  <td style={td}><span style={{ color: '#52c41a' }}>{b.completed_count || 0}</span> / <span style={{ color: '#ff4d4f' }}>{b.failed_count || 0}</span></td>
                  <td style={td}>{getStatusBadge(b.status)}</td>
                  <td style={{ ...td, color: '#999', fontSize: 12 }}>{b.created_at?.slice(0, 16)}</td>
                  <td style={td}>
                    <button onClick={() => viewBatchDetail(b.id)} style={{ ...btnStyle, background: '#1890ff', color: '#fff' }}>查看</button>
                    {b.completed_count > 0 && b.status !== 'codes_generated' && <button onClick={() => generateCodes(b.id)} style={{ ...btnStyle, background: '#52c41a', color: '#fff', marginLeft: 8 }}>生成领取码</button>}<button onClick={() => deleteBatch(b.id)} style={{ ...btnStyle, background: '#ff4d4f', color: '#fff', marginLeft: 8 }}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {batchDetail && (
        <div style={overlay} onClick={() => setBatchDetail(null)}>
          <div style={{ ...modal, width: 640 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3>批次详情</h3><button onClick={() => setBatchDetail(null)} style={{ ...btnStyle, background: '#f5f5f5' }}>关闭</button>
            </div>
            <div style={{ marginBottom: 16, padding: 16, background: '#f6ffed', borderRadius: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}><span>批次ID</span><span style={{ fontFamily: 'monospace' }}>{batchDetail.id}</span></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}><span>总任务数</span><span>{batchDetail.tasks_count} 个</span></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}><span>字幕样式</span><span>{batchDetail.subtitle_font_size}px · {batchDetail.subtitle_color} · {batchDetail.subtitle_position === 'bottom' ? '底部' : batchDetail.subtitle_position === 'middle' ? '中间' : '顶部'}</span></div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>状态</span>{getStatusBadge(batchDetail.status)}</div>
            </div>
            <h4 style={{ marginBottom: 12 }}>任务列表</h4>
            <div style={{ maxHeight: 320, overflow: 'auto' }}>
              {batchDetail.tasks?.map(t => {
                const codes = batchCodes[t.id] || []
                const code = codes[0]
                const claimUrl = code ? `${API.replace('/api','')}/claim.html?code=${code.code}` : null
                return (
                  <div key={t.id} style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                      <div><div style={{ fontWeight: 500 }}>{t.child_name}</div><div style={{ fontSize: 12, color: '#999' }}>{t.title}</div></div>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        {t.output_url && <button onClick={() => window.open(window.location.origin + t.output_url, '_blank')} style={{ ...btnStyle, background: '#1890ff', color: '#fff' }}>▶ 预览</button>}
                        {getStatusBadge(t.status)}
                      </div>
                    </div>
                    {code && (
                      <div style={{ background: '#f5f5f5', borderRadius: 8, padding: '8px 12px' }}>
                        <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>
                          领取码：<span style={{ fontFamily: 'monospace', fontSize: 13, color: '#722ed1', letterSpacing: 2 }}>{code.code}</span>
                          {code.status === 'redeemed' && <span style={{ color: '#fa8c16', marginLeft: 8 }}>已领取</span>}
                          {code.status === 'available' && <span style={{ color: '#52c41a', marginLeft: 8 }}>待领取</span>}
                        </div>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button onClick={() => copyToClipboard(claimUrl)} style={{ ...btnStyle, background: '#1890ff', color: '#fff', fontSize: 11, padding: '4px 10px' }}>📋 复制链接</button>
                          <button onClick={() => sendSms(t.child_name, claimUrl)} style={{ ...btnStyle, background: '#52c41a', color: '#fff', fontSize: 11, padding: '4px 10px' }}>💬 短信发送</button>
                        </div>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btnStyle = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
const labelStyle = { display: 'block', marginBottom: 4, fontSize: 12, color: '#999' }
const inputStyle = { width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13 }
const overlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modal = { background: '#fff', borderRadius: 8, padding: 24, maxHeight: '85vh', overflow: 'auto' }
